export const QUICK_START_MODAL_DISMISSED_KEY = "qit:quick-start-modal-dismissed";
export const OPEN_QUICK_START_MODAL_EVENT = "qit:open-quick-start-modal";

export const dismissQuickStartModal = () => {
    if (typeof window === "undefined") return;
    try { window.sessionStorage.setItem(QUICK_START_MODAL_DISMISSED_KEY, "1"); } catch {
        // Joining a session must still work when storage is unavailable.
    }
};

export const resetQuickStartModalDismissal = () => {
    if (typeof window === "undefined") return;
    try {
        window.sessionStorage.removeItem(QUICK_START_MODAL_DISMISSED_KEY);
    } catch {
        // Storage may be unavailable in private or restricted browser modes.
    }
};

export const openQuickStartModal = () => {
    if (typeof window === "undefined") return;
    resetQuickStartModalDismissal();
    window.dispatchEvent(new CustomEvent(OPEN_QUICK_START_MODAL_EVENT));
};
